import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import Region from "../../../../Utility/Crud/Region";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminRegionList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "name", name: "Name", type: "string" },
                    { key: "regionTypeTermId", name: "Type", type: "term", filter: true },
                    { key: "directorUserprofileId", name: "Director", type: "user" }
                ]}
                sort={[
                    {
                        key: "regionTypeTermId",
                        direction: "ascending",
                        type: "term",
                    },
                    {
                        key: "name",
                        direction: "ascending",
                        type: "term",
                    },
                ]}
                rows={Region.sort(Object.values(this.context.regionsIndexed))}
                onClick={(region) => {
                    this.props.history.push({
                        pathname: "/admin/region/" + region.id
                    });
                }}
            />
        );
    }
});